import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { siteWide } from '@helpers/grid';
import { Layers } from '@helpers/layers';
import styled from 'styled-components';
const Container = styled.div `
  ${siteWide};

  position: relative;
  z-index: ${Layers.Navigation - 1};
  height: 0;

  &:not(:focus-within) {
    z-index: ${Layers.Navigation * -1};
    pointer-events: none;
  }
`;
const Button = styled.button `
  ${ButtonReset};
  ${transition('opacity, transform')};
  ${fonts.lato.bold};

  position: absolute;
  left: 0;
  top: 0;
  margin: 0;
  opacity: 0;
  transform: translate(3px, -100%);
  background-color: ${brand.secondary.yellow.light};
  color: ${brand.global.black};
  padding: 8px 12px;
  border-radius: 50px;
  font-size: 16px;

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-style: solid;
    outline-width: 2px;
    outline-color: ${brand.global.black};
    opacity: 1;
    transform: translate(3px, 3px);
  }
`;
const SkipLinkStyles = {
    Container,
    Button,
};
export default SkipLinkStyles;
